import {CartItem, CartItemAction, Currency, Price} from "../../../index";

interface CartProps {
  items: CartItem[];
}

class Cart {
  constructor(private _: CartProps) {}

  static fromJson(json: any) {
    return new Cart({
      items: json.items?.map((item: any) => CartItem.fromJson(item)) || [],
    });
  }

  get items() {
    return this._.items;
  }

  addItem(item: CartItem) {
    this._.items.push(item);
  }

  removeItem(item: CartItem) {
    this._.items = this._.items.filter(
      (i) => i._.internalAddOnId !== item._.internalAddOnId
    );
  }

  toggleItem(item: CartItem) {
    if (this._.items.some((i) => i.equals(item, true, false, true))) {
      this.removeItem(item);
    } else {
      this.addItem(item);
    }
  }

  setItems(items: CartItem[]) {
    this._.items = items;
  }

  toJson(withAddOn: boolean = true) {
    return {
      items: this._.items.map((item) => item.toJson(withAddOn)),
    };
  }

  get currency() {
    return this._.items[0]?._.price?.currency || Currency.defaultValue;
  }

  get total() {
    const total = this._.items.reduce((acc, cartItem) => {
      if (cartItem._.action === CartItemAction.REMOVE) {
        return (acc - (cartItem._.price?.amount || 0)) * cartItem._.quantity;
      } else {
        return (acc + (cartItem._.price?.amount || 0)) * cartItem._.quantity;
      }
    }, 0);
    return new Price({ amount: total, currency: this.currency });
  }
}

export { Cart };
